<template>
  <div class="container">
      <main>
            <Search @getInputValue='getInputValue' @search='search' @add='add'>设备管理</Search>
            <el-table
                :data="list"
                header-align="center"
                :row-class-name="TableRowClassName"
                style="width:100%;padding:0 0px;height:100%"
                :header-cell-style="{ background: '#EBEEF8',height: '45px' }"
                :cell-style="{padding:'0px'}"
            >
            <el-table-column
            label="序号"
            type="index"
            :index="indexMethod"
            align="center"
            >
            </el-table-column>
            <el-table-column
            prop="status"
            label="状态"
            align="center"
            show-overflow-tooltip
            >
            <template slot-scope="scope">
                <span :style="{color:scope.row.status==0?'#ccc':'#00ff00'}">{{scope.row.status==0?'试运行':'正式'}}</span>
            </template>
            </el-table-column>
            <el-table-column
            prop="machineNo"
            label="设备编号"
            align="center"
            show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
            prop="factorNo"
            label="出厂编号"
            align="center"
            show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
            prop="type"
            label="设备类型"
            align="center"
            show-overflow-tooltip
            >
             <template slot-scope="scope">
                <span>{{scope.row.type==1?'塔机':'升降机'}}</span>
            </template>
            </el-table-column>
            <el-table-column
            prop="model"
            label="规格型号"
            align="center"
            show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
            prop="productDate"
            label="出厂日期"
            align="center"
            show-overflow-tooltip
            >
            <template slot-scope="scope">
                <span>{{scope.row.productDate | timeFomart}}</span>
            </template>
            </el-table-column>
            <el-table-column
            prop="sendDate"
            label="发货日期"
            align="center"
            show-overflow-tooltip
            >
            <template slot-scope="scope">
                <span>{{scope.row.sendDate | timeFomart}}</span>
            </template>
            </el-table-column>
            <el-table-column
            prop="customerName"
            label="客户名称"
            align="center"
            show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
            prop="salesCompanyName"
            label="销售公司"
            align="center"
            show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
            label="操作"
            align="center"
            fixed="right"
            min-width="80"
            width="130"
            >
                <template slot-scope="scope">
                    <div style="display:flex;width:100%;justify-content:space-around;align-items:center">
                        <el-button @click="lockShow(scope.row)" slot="reference" type="text" size="mini" class="btn">
                            <i v-if="scope.row.lockState==0" class="iconfont1" title="未锁机" style="fontSize:19px;color:#6D9E7B">&#xe625;</i>
                            <i v-if="scope.row.lockState==1" class="iconfont1" title="已锁机" style="fontSize:19px;color:#AD454E">&#xe615;</i>
                        </el-button>
                        <el-button @click="attentionShow(scope.row)" slot="reference" type="text" size="mini" class="btn">
                            <i v-if="scope.row.attention==0" class="el-icon-star-off" title="未关注" style="fontSize:20px;color:#EDB941"></i>
                            <i v-if="scope.row.attention==1" class="el-icon-star-on" title="已关注" style="fontSize:25px;color:#EDB941;"></i>
                        </el-button>
                        
                            <el-button @click="edit(scope.row)" type="text" size="mini" class="btn">
                            <i class="el-icon-edit-outline" title="编辑" style="fontSize:19px;color:#000;"></i>
                        </el-button>
                        <el-button v-if="user.systemRole==1 || user.systemRole==3" :disabled='scope.row.status!=0' @click="ToOk(scope.row)" type="text" size="mini" class="btn">
                            <i class="el-icon-finished" title="设备转正式" style="fontSize:19px;"></i>
                        </el-button>
                    </div>
                </template>
            </el-table-column>
            </el-table>
            <Pagination :pageTotal="pageTotal" @currentPage="currentPage"/>
        </main>
        <el-dialog :title="isEdit?'编辑':'新增'"  :visible.sync="dialogFormVisible" center :close-on-click-modal="false" style="width:100%;margin:0 auto;marginTop:-50px;overflow:hidden;">
            <div class="dialogline"></div>
            <el-form :model="dialogForm" class="dialogForm" :rules="formRules" ref="formRules" >
                <div class="formbigdiv">
                    <div class="formdiv" style="width:40%">
                        <el-form-item label="出厂编号" label-width="80px" prop="factorNo" >
                            <el-input v-model="dialogForm.factorNo" autocomplete="off" placeholder="请输入出厂编号" @change="factoryChange"></el-input>
                        </el-form-item>
                        <el-form-item label="设备编号" label-width="80px" prop="machineNo">
                            <el-input v-model="dialogForm.machineNo" autocomplete="off" placeholder="请输入设备编号" ></el-input>
                        </el-form-item>
                        <el-form-item label="设备类型" label-width="80px" prop="type">
                            <el-select  v-model="dialogForm.type" style="width:100%" @change="typeChange">
                                <el-option label="塔机" value='1'></el-option>
                                <el-option label="升降机" value='2'></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="规格型号" label-width="80px" prop="modelId" >
                            <el-select  v-model="dialogForm.modelId" placeholder="请选择规格型号" style="width:100%" filterable>
                                <el-option v-for="(item,i) in modelList" :key="i" :label="item.model" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="电控形式" label-width="80px" prop="eleControl" >
                            <el-input v-model="dialogForm.eleControl" autocomplete="off" placeholder="请输入电控形式" ></el-input>
                        </el-form-item>
                        <el-form-item label="出厂日期" label-width="80px" prop="productDate">
                            <el-date-picker
                                v-model="dialogForm.productDate"
                                type="date"
                                @change="selectValue"
                                style="width:100%"
                                placeholder="请选择出厂日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="截面大小" v-if="type==1" label-width="80px" prop="section">
                            <el-input v-model="dialogForm.section" autocomplete="off" placeholder="请输入截面大小">
                                <template slot="append">米</template>
                            </el-input>
                        </el-form-item>
                        <el-form-item label="使用年限" label-width="80px" prop="maxLife">
                            <el-input v-model="dialogForm.maxLife" autocomplete="off" placeholder="请输入使用年限">
                                <template slot="append">年</template>
                            </el-input>
                        </el-form-item>
                        <el-form-item label="监控主机" label-width="80px" prop="deviceId"  v-if="this.dialogForm.type==1">
                            <el-select  v-model="deviceName" placeholder="请选择规格型号" style="width:100%" filterable @change="deviceChange" clearable>
                                <el-option v-for="(item,i) in deviceList" :key="i" :label="item.imei" :value="item"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="左笼监控" label-width="80px" prop="deviceId" v-if="this.dialogForm.type==2">
                            <el-select  v-model="deviceName" placeholder="请选择规格型号" style="width:100%" filterable @change="deviceChange" clearable>
                                <el-option v-for="(item,i) in deviceList" :key="i" :label="item.imei" :value="item"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="右笼监控" label-width="80px" prop="deviceRightId" v-if="this.dialogForm.type==2">
                            <el-select  v-model="deviceRightName" placeholder="请选择规格型号" style="width:100%" filterable @change="deviceRightChange" clearable>
                                <el-option v-for="(item,i) in deviceList" :key="i" :label="item.imei" :value="item"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="formdiv" style="flex:1">
                        <el-button type="primary" icon="el-icon-plus" style="margin-left:10px;margin-bottom:10px;background:#ebeef8;border:none;color:#909399;font-weight:bold" @click="add2">新增</el-button>
                        <el-table
                            :data="dialogForm.viodes"
                            header-align="center"
                            :row-class-name="TableRowClassName"
                            style="width:98%;padding:0;height:100%;margin-left:10px;border:1px solid #eee"
                            :header-cell-style="{ background: '#EBEEF8',height:'45px'}"
                            :cell-style="{padding:'0px'}"
                            height="485px"
                        >
                            <el-table-column
                            label="序号"
                            type="index"
                            :index="indexMethod"
                            align="left"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="sceneNo"
                            label="视频位置"
                            align="center"
                            >
                             <template scope="scope" >
                                <el-input size="mini" v-model="scope.row.sceneNo" placeholder="视频位置"/>
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="videoId"
                            label="视频序号"
                            align="center"
                            width="130"
                            show-overflow-tooltip
                            >
                            <template scope="scope" >
                                <el-select v-model="scope.row.videoId" placeholder="视频序号" size="mini" filterable >
                                    <el-option v-for="(item,i) in videoData" :key="i" :label="item.serialNum" :value="item.videoId" ></el-option>
                                </el-select>
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="deviceId"
                            label="监控主机"
                            align="center"
                            show-overflow-tooltip
                            width="180"
                            >
                            <template scope="scope" >
                                <el-select  v-model="scope.row.deviceId" placeholder="监控主机" size="mini" filterable>
                                    <el-option v-for="(item,i) in deviceAble" :key="i" :label="item.imei" :value="item.id"></el-option>
                                </el-select>
                            </template>
                            </el-table-column>
                            <el-table-column
                            label="操作"
                            align="center"
                            width="50"
                            >
                            <template slot-scope="scope">
                                <div style="display:flex;width:100%;justify-content:space-around">
                                    <el-button @click="delete2(scope.row,scope.$index)" type="text" size="mini" class="btn">
                                        <i class="el-icon-delete" style="fontSize:19px;color:red"></i>
                                    </el-button>
                                </div>
                            </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer" >
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmForm">{{isEdit?'保 存':'确 定'}}</el-button>
            </div>
        </el-dialog>
        <el-dialog title="设备转正式"  :visible.sync="dialogFormVisible2" center :close-on-click-modal="false" style="width:60%;margin:0 auto;marginTop:-70px">
            <div class="dialogline"></div>
            <!-- <div class="dialogdiv"> -->
                <el-form :model="dialogForm2" class="dialogForm" :rules="formRules2" ref="formRules2">
                    <el-form-item label="合同编号" label-width="80px" style="height:29px" prop="contractNo">
                        <el-input v-model="dialogForm2.contractNo" autocomplete="off" placeholder="请输入合同编号" ></el-input>
                    </el-form-item>
                    <el-form-item label="客户名称" label-width="80px" style="height:29px" prop="customerId" filterable>
                        <el-select  v-model="dialogForm2.customerId" placeholder="请选择客户名称" style="width:100%" filterable>
                            <el-option v-for="item in customerList" :key="item.id" :label="item.name" :value='item.id'></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="付款方式" label-width="80px" style="height:29px" prop="purchaseMethod">
                        <el-select  v-model="dialogForm2.purchaseMethod" placeholder="请选择付款方式" style="width:100%" @change="fukuanChange">
                            <el-option label="全款" value='1'></el-option>
                            <el-option label="贷款" value='2'></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="fukuanType==2" label="分期数" label-width="80px" style="height:29px" prop="periodsNum" >
                        <el-input v-model="dialogForm2.periodsNum" autocomplete="off" placeholder="请输入分期数" ></el-input>
                    </el-form-item>
                    <el-form-item v-if="fukuanType==2" label="按揭开始" label-width="80px" style="height:29px" prop="startDate">
                        <el-date-picker
                            style="width:100%"
                            v-model="dialogForm2.startDate"
                            type="date"
                            @change="selectValue1"
                            placeholder="请选择按揭开始日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="销售公司" label-width="80px" style="height:29px" prop="salesCompanyId" >
                        <el-select  v-model="dialogForm2.salesCompanyId" placeholder="请选择销售公司" style="width:100%" filterable>
                            <el-option v-for="item in salesCompanyList" :key="item.id" :label="item.name" :value='item.id'></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="销售经理" label-width="80px" style="height:29px" prop="salesPerson">
                        <el-input v-model="dialogForm2.salesPerson" autocomplete="off" placeholder="请输入销售经理姓名" ></el-input>
                    </el-form-item>
                    <el-form-item label="联系电话" label-width="80px" style="height:29px" prop="salesPersonTel">
                        <el-input v-model="dialogForm2.salesPersonTel" autocomplete="off" placeholder="请输入联系电话" ></el-input>
                    </el-form-item>
                    <el-form-item label="发货日期" label-width="80px" style="height:29px" prop="sendDate">
                        <el-date-picker
                            style="width:100%"
                            v-model="dialogForm2.sendDate"
                            type="date"
                            @change="selectValue2"
                            placeholder="请选择发货日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="发货地区" label-width="80px" style="height:29px" prop="areaCode">
                        <el-cascader
                            style="width:100%"
                            v-model="dialogForm2.areaCode"
                            filterable
                            clearable
                            :props="defaultProps"
                            :options="addressTree"
                            @change="handleChange">
                        </el-cascader>
                    </el-form-item>
                    <el-form-item label="详细地址" label-width="80px" style="height:29px" prop="sendAddress" >
                        <el-input v-model="dialogForm2.sendAddress" autocomplete="off" placeholder="请输入详细地址" @input="getAddress"></el-input>
                    </el-form-item>
                </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible2 = false">取 消</el-button>
                <el-button type="primary" @click="confirmForm2">{{isEdit?'保 存':'确 定'}}</el-button>
            </div>
        </el-dialog>
        <el-dialog width="25%" center :visible.sync="lockDialogShow" style="margin-top: 10%;">
            <template slot="title">
                <div style="color: #AD454E;font-size:20px">重要提示</div>
            </template>
            <div class="dialog">
                <div class="dialog-content" v-if="lockStatus==0"><span style="margin-left:35px;">该</span>操作将会锁止起重设备，会导致设备运行速度减半甚至关停，影响重大，请审慎操作！</div>
                <div class="dialog-content" v-if="lockStatus==1"><span style="margin-left:35px;">该</span>操作将会解锁起重设备，使设备恢复正常使用，请确认您的操作！</div>
                <div class="dialog-footer">
                    <button class="dialog-btn" :style="{background:lockStatus==0?'#ad454e':'#6d9e7b'}" @click="lockConfirm">{{lockStatus==0?'确认锁机':'确认解锁'}}</button>
                    <button class="dialog-btn btn2" @click="lockDialogShow = false">放弃操作</button>
                </div>
            </div>
        </el-dialog>
        <el-dialog width="25%" center :visible.sync="attentionDialogShow" style="margin-top: 10%;">
            <template slot="title">
                <div style="color: #AD454E;font-size:20px">重要提示</div>
            </template>
            <div class="dialog">
                <div class="dialog-content" v-if="attention==0"><span style="margin-left:35px;">该</span>操作将会关注起重设备，被关注的设备将会展示在大屏“关注设备”中！</div>
                <div class="dialog-content" v-if="attention==1"><span style="margin-left:35px;">该</span>操作将会取消关注起重设备，被取消关注的设备将不再出现于大屏“关注设备”中！</div>
                <div class="dialog-footer">
                    <button class="dialog-btn" :style="{background:attention==0?'#6d9e7b':'#ad454e'}" @click="attentionConfirm">{{attention==0?'确认关注':'确认取关'}}</button>
                    <button class="dialog-btn btn2" @click="attentionDialogShow = false">放弃操作</button>
                </div>
            </div>
        </el-dialog>
  </div>
</template>

<script>
import '../assets/js/timeFomart'
export default {
    data(){
        return{
            option: {
                filter: '',
                pageSize: 15,
                pageIndex: 1
            },
            customerOption: {
                filter: '',
                pageSize: 100000,
                pageIndex: 1
            },
            saleOption: {
                filter: '',
                pageSize: 100000,
                pageIndex: 1
            },
            videoOption: {
                filter: '',
                pageSize: 100000,
                pageIndex: 1
            },
            deviceOption: {
                filter: '',
                pageSize: 100000,
                pageIndex: 1
            },
            modelOption: {
                filter: '',
                pageSize: 100000,
                pageIndex: 1
            },
            dialogForm: {
                id: 0,
                machineNo: '',
                factorNo: '',
                type: '1',
                deviceId: '',
                deviceRightId: '',
                modelId: '',
                eleControl: '',
                section: '',
                maxLife: '',
                productDate: '',
                viodes: [],
            },
            dialogForm2:{
                id: 0,
                contractNo: '',
                customerId: '',
                salesCompanyId: '',
                salesPerson: '',
                salesPersonTel: '',
                purchaseMethod: '',
                periodsNum: '',
                startDate: '1991-01-01',
                sendDate: '',
                areaCode: '',
                sendAddress: ''
            },
            center: {
                lng: 116.404,
                lat: 39.915,
            },
            zoom: 15,
            markerCenter:{
                lng: 116.404,
                lat: 39.915,
            },
            formRules:{
                machineNo:[{
                    required: true,
                    message: "请输入设备编号",
                    trigger: "blur"
                }],
                type:[{
                    required: true,
                    message: "请选择设备类型",
                    trigger: "blur"
                }],
                factorNo:[{
                    required: true,
                    message: "请输入出厂编号",
                    trigger: "blur"
                }],
                modelId:[{
                    required: true,
                    message: "请选择规格型号",
                    trigger: "blur"
                }],
                eleControl:[{
                    required: true,
                    message: "请输入电控形式",
                    trigger: "blur"
                }],
                productDate:[{
                    required: true,
                    message: "请选择出厂日期",
                    trigger: "blur"
                }],
                section:[{
                    required: true,
                    message: "请输入截面大小",
                    trigger: "blur"
                }],
                maxLife:[{
                    required: true,
                    message: "请输入使用年限",
                    trigger: "blur"
                }],
            },
            formRules2:{
                contractNo:[{
                    required: true,
                    message: "请输入合同编号",
                    trigger: "blur"
                }],
                customerId:[{
                    required: true,
                    message: "请选择客户",
                    trigger: "blur"
                }],
                salesCompanyId:[{
                    required: true,
                    message: "请选择销售公司",
                    trigger: "blur"
                }],
                salesPerson:[{
                    required: true,
                    message: "请输入销售经理姓名",
                    trigger: "blur"
                }],
                salesPersonTel:[{
                    required: true,
                    message: "请输入联系电话",
                    trigger: "blur"
                }],
                purchaseMethod:[{
                    required: true,
                    message: "请选择付款方式",
                    trigger: "blur"
                }],
                periodsNum:[{
                    required: true,
                    message: "请输入分期数",
                    trigger: "blur"
                }],
                startDate:[{
                    required: true,
                    message: "请选择按揭开始日期",
                    trigger: "blur"
                }],
                sendDate:[{
                    required: true,
                    message: "请选择发货日期",
                    trigger: "blur"
                }],
                areaCode:[{
                    required: true,
                    message: "请选择发货地区",
                    trigger: "blur"
                }],
                sendAddress:[{
                    required: true,
                    message: "请输入详细地址",
                    trigger: "blur"
                }],
            },
            defaultProps: {
                children: "children",
                label: "title",
                value:'code',
                checkStrictly: true
            },
            pageTotal: 1,
            isEdit: false,
            dialogFormVisible: false,
            isEdit2: false,
            dialogFormVisible2: false,
            list: [],
            inputValue: '',
            addressTree: [],
            videoData: [],
            deviceList: [],
            modelList: [],
            type: 1,
            deviceAbleLeft: [],
            deviceAbleRight: [],
            deviceAble: [],
            deviceName:'',
            deviceRightName: '',
            user:{},
            customerList: [],
            salesCompanyList: [],
            fukuanType: '1',
            lockDialogShow:false,
            lockStatus:0,
            imei: '',
            attentionDialogShow:false,
            attention:0,
        }
    },
    methods:{
        //获取list
        getList(option){
            this.$api.MachineList(option).then(res=>{
                this.list = res.data.data.data;
                this.pageTotal = res.data.data.total;
            })
        },
        //获取视频列表
        getVideoList(option){
            this.$api.UnUseVideoList(option).then(res=>{
                this.videoData = res.data.data.data;
            })
        },
        //获取监控列表
        getDeviceList(option){
            this.$api.UnUseDeviceList(option).then(res=>{
                this.deviceList = res.data.data.data;
            })
        },
        //获取规格型号
        getModelList(option){
            this.$api.JModelList(option).then(res=>{
                this.modelList = res.data.data.data;
            })
        },
        //获取客户列表
        getCustomerList(option){
            this.$api.CustomerList(option).then(res=>{
                this.customerList = res.data.data.data;
            })
        },
        //获取销售公司列表
        getSalesCompanyList(option){
            this.$api.SalesCompanyList(option).then(res=>{
                this.salesCompanyList = res.data.data.data;
            })
        },
        //设备类型改变
        typeChange(val){
            this.type = val;
            this.deviceAble = [];
            this.deviceName = '';
            this.deviceRightName = '';
        },
        //出厂编号改变
        factoryChange(val){
            this.dialogForm.machineNo = val;
        },
        //左笼监控改变
        deviceChange(val){
            if(val){
                this.dialogForm.deviceId = val.id;
                this.deviceName = val.imei;
                this.deviceAbleLeft[0] = val;
                if(this.deviceAble.length !=0){
                    this.deviceAble[1] = this.deviceAbleLeft[0];
                }else{
                    this.deviceAble[0] = this.deviceAbleLeft[0];
                }
            }else{
                this.deviceAble.splice(0,1)
                this.dialogForm.deviceId = '';
            }
        },
        //右笼监控改变
        deviceRightChange(val){
            if(val){
                this.dialogForm.deviceRightId = val.id;
                this.deviceRightName = val.imei;
                this.deviceAbleRight[0] = val;
                if(this.deviceAble.length==0){
                    this.deviceAble[0] = this.deviceAbleRight[0];
                }else{
                    this.deviceAble[1] = this.deviceAbleRight[0];
                }
            }else{
                if(this.deviceAble.length == 1){
                    this.deviceAble.splice(0,1)
                }
                if(this.deviceAble.length == 2){
                    this.deviceAble.splice(1,1)
                }
                this.dialogForm.deviceRightId = '';
            }
        },
        //获取地区树
        getAddressTree(){
            this.$api.GetAreaTree().then(res=>{
                this.addressTree = JSON.parse(res.data.data)
            })
        },
        //地区选择框改变
        handleChange(val){
            this.dialogForm2.areaCode = val[this.dialogForm2.areaCode.length-1];
        },
        //付款方式改变
        fukuanChange(val){
            this.fukuanType = val;
        },
        //获取页码
        currentPage(option){
            this.option.pageIndex = option
            this.getList(this.option);
        },
        //表格前编号
        indexMethod(index) {
            return index+1 ;
        },
        //表格隔行变色，样式在app.vue里
        TableRowClassName({row,rowIndex}){
            if(rowIndex%2 != 0){
                return 'backtablegray'
            }else{
                return 'backtablewhite'
            }
        },
        //获取搜索框值
        getInputValue(option){
            this.inputValue = option
        },
        //搜索按钮
        search(){
            this.getList({
                filter: this.inputValue,
                pageSize: 15,
                pageIndex: 1
            });
        },
        //获取项目地址
        getAddress(){
            this.center = this.dialogForm.address;
        },
        //点击地图获取坐标
        getLocation(e){
            this.markerCenter.lng = e.point.lng;
            this.markerCenter.lat = e.point.lat;
            this.dialogForm.gpsX =  e.point.lng;
            this.dialogForm.gpsY =  e.point.lat
        },
        //选择出厂日期
        selectValue(){
            this.dialogForm.productDate = this.dialogForm.productDate.format("yyyy-MM-dd");
        },
        //选择按揭开始日期
        selectValue1(){
            this.dialogForm2.startDate = this.dialogForm2.startDate.format("yyyy-MM-dd");
        },
        //选择发货日期
        selectValue2(){
            this.dialogForm2.sendDate = this.dialogForm2.sendDate.format("yyyy-MM-dd");
        },
        //点击锁机按钮
        lockShow(row){
            this.lockDialogShow = true;
            this.lockStatus = row.lockState;
            this.imei = row.imei?row.imei:row.imeiRight
        },
        //锁机的确定按钮
        lockConfirm(){
            this.$api.DeviceLock({imei:this.imei}).then(res=>{
                if(res.data.code == 200){
                    this.$notify({
                        message: res.data.msg,
                        type: 'success'
                    })
                }else{
                    this.$notify({
                        message: res.data.msg,
                        type: 'error'
                    })
                }
                this.getList(this.option);
                this.lockDialogShow = false;
            })
        },
        //点击关注按钮
        attentionShow(row){
            this.attentionDialogShow = true;
            this.attention = row.attention;
            this.imei = row.imei?row.imei:row.imeiRight;
        },
        //关注的确定
        attentionConfirm(){
            this.$api.FocusImei({imei:this.imei}).then(res=>{
                if(res.data.code == 200){
                    this.$notify({
                        message: res.data.msg,
                        type: 'success'
                    })
                }else{
                    this.$notify({
                        message: res.data.msg,
                        type: 'error'
                    })
                }
                this.getList(this.option);
                this.attentionDialogShow = false;
            })
        },
        //添加按钮
        add(){
            this.isEdit = false;
            this.dialogFormVisible = true;
            this.deviceAble = [];
            this.deviceName = '';
            this.deviceRightName = '';
            this.dialogForm = {
                id: 0,
                machineNo: '',
                factorNo: '',
                type: '1',
                deviceId: '',
                deviceRightId: '',
                modelId: '',
                eleControl: '',
                section: '',
                maxLife: '',
                productDate: '',
                viodes: [],
            },
            this.center = {
                lng: 116.404,
                lat: 39.915,
            }
            this.markerCenter = {
                lng: 116.404,
                lat: 39.915,
            }
        },
        add2(){
            this.getVideoList(this.videoOption);
            this.dialogForm.viodes.push({
                id: 0,
                videoId: '',
                machineId: 0,
                deviceId: '',
                sceneNo: ''
            })
        },
        //编辑按钮
        edit(row) {
            this.getList(this.option);
            this.isEdit = true;
            this.dialogFormVisible = true;
            this.type = String(row.type);
            
            if(row.type==1){
                this.deviceAble[0] = {
                    id:row.deviceId,
                    imei:row.imei
                };
            }else{
                if(row.deviceId && !row.deviceRightId){
                    this.deviceAble[0] = {
                        id:row.deviceId,
                        imei:row.imei
                    };
                }
                if(row.deviceRightId && !row.deviceId){
                    this.deviceAble[0] = {
                        id:row.deviceRightId,
                        imei:row.imeiRight
                    };
                }
                if(row.deviceId && row.deviceRightId){
                    this.deviceAble[0] = {
                        id:row.deviceId,
                        imei:row.imei
                    };
                    this.deviceAble[1] = {
                        id:row.deviceRightId,
                        imei:row.imeiRight
                    };
                }
            }
           
            this.deviceName = row.imei;
            this.deviceRightName = row.imeiRight;
            this.$api.UnUseVideoList(this.videoOption).then(res=>{
                this.videoData = []
                this.videoData = res.data.data.data;
                row.videoList.map(item=>{
                    this.videoData.push({
                        id: item.videoId,
                        videoId: item.videoId,
                        serialNum: item.serialNum,
                    })
                })
            })
            this.dialogForm = {
                id: row.id,
                machineNo: row.machineNo,
                factorNo: row.factorNo,
                type: String(row.type),
                deviceId: String(row.deviceId),
                deviceRightId: String(row.deviceRightId),
                modelId: row.modelId,
                eleControl: row.eleControl,
                section: row.section,
                maxLife: row.maxLife,
                productDate: row.productDate,
                viodes: row.videoList,
            };
            this.center = {
                lng: row.gpsX,
                lat: row.gpsY,
            }
            this.markerCenter = {
                lng: row.gpsX,
                lat: row.gpsY,
            }
        },
        ToOk(row){
            this.dialogFormVisible2 = true;
            this.dialogForm2 = {
                id: row.id,
                contractNo: '',
                customerId: '',
                salesCompanyId: '',
                salesPerson: '',
                salesPersonTel: '',
                purchaseMethod: '',
                periodsNum: '',
                startDate: '',
                sendDate: '',
                areaCode: '',
                sendAddress: ''
            }
        },
        delete2(row,index){
            this.dialogForm.viodes.splice(this.dialogForm.viodes.findIndex((item,i) => i == index), 1)
        },
        //dialog提交按钮
        confirmForm(){
            this.$refs.formRules.validate(valid=>{
                if(valid){
                    //可以提交
                    var flag = true;
                    this.dialogForm.type = Number(this.dialogForm.type);
                    this.dialogForm.deviceId = Number(this.dialogForm.deviceId);
                    this.dialogForm.deviceRightId = Number(this.dialogForm.deviceRightId);
                    this.dialogForm.modelId = Number(this.dialogForm.modelId);
                    this.dialogForm.section = Number(this.dialogForm.section);
                    this.dialogForm.maxLife = Number(this.dialogForm.maxLife);
                    if(this.dialogForm.deviceId == this.dialogForm.deviceRightId && (this.dialogForm.deviceId !=0 && this.dialogForm.deviceRightId !=0)){
                        this.$notify({
                            message: '左右笼监控重复！',
                            type: 'error'
                        })
                        flag = false
                        return
                    }
                    this.dialogForm.viodes.map(item=>{
                        item.videoId = Number(item.videoId);
                        item.deviceId = Number(item.deviceId);
                        if(item.sceneNo==''){
                            this.$notify({
                                message: '未输入视频位置！',
                                type: 'error'
                            })
                            flag = false
                            return ;
                        }
                        if(item.videoId==0){
                            this.$notify({
                                message: '未选择视频序号！',
                                type: 'error'
                            })
                            flag = false
                            return ;
                        }
                        if(item.deviceId==0){
                            this.$notify({
                                message: '未选择监控主机！',
                                type: 'error'
                            })
                            flag = false
                            return flse;
                        }
                    })
                    if(flag){
                        if(this.isEdit){
                            this.$api.UpdateMachine(this.dialogForm).then(res=>{
                                if(res.data.code == 200){
                                    this.getList(this.option);
                                    this.getVideoList(this.videoOption);
                                    this.getDeviceList(this.deviceOption);
                                    this.$notify({
                                        message: res.data.msg,
                                        type: 'success'
                                    })
                                }else{
                                    this.$notify({
                                        message: res.data.msg,
                                        type: 'error'
                                    })
                                }
                            })
                        }else{
                            this.$api.AddMachine(this.dialogForm).then(res=>{
                                if(res.data.code == 200){
                                    this.getList(this.option);
                                    this.getVideoList(this.videoOption);
                                    this.getDeviceList(this.deviceOption);
                                    this.$notify({
                                        message: res.data.msg,
                                        type: 'success'
                                    })
                                }else{
                                    this.$notify({
                                        message: res.data.msg,
                                        type: 'error'
                                    })
                                }
                            })
                        }
                        this.dialogFormVisible = false;
                    }
                    
                }else{
                    return false
                }
            })
        },
        //dialog2提交按钮
        confirmForm2(){
            this.$refs.formRules2.validate(valid=>{
                if(valid){
                    this.dialogForm2.customerId = Number(this.dialogForm2.customerId);
                    this.dialogForm2.salesCompanyId = Number(this.dialogForm2.salesCompanyId);
                    this.dialogForm2.purchaseMethod = Number(this.dialogForm2.purchaseMethod);
                    this.dialogForm2.periodsNum = Number(this.dialogForm2.periodsNum);
                    if(this.fukuanType == 1){
                        this.dialogForm2.startDate = '1991-01-01'
                    }
                    this.$api.MachineToOk(this.dialogForm2).then(res=>{
                        if(res.data.code == 200){
                            this.getList(this.option);
                            this.$notify({
                                message: res.data.msg,
                                type: 'success'
                            })
                        }else{
                            this.$notify({
                                message: res.data.msg,
                                type: 'error'
                            })
                        }
                    })
                    this.dialogFormVisible2 = false;
                }else{
                    return false
                }
            })
        }
    },
    created(){
        this.user = JSON.parse(localStorage.getItem('user'))
    },
    mounted(){
        this.getList(this.option);
        this.getAddressTree();
        this.getVideoList(this.videoOption);
        this.getDeviceList(this.deviceOption);
        this.getModelList(this.modelOption);
        this.getCustomerList(this.customerOption);
        this.getSalesCompanyList(this.saleOption);
    }
}
</script>

<style lang='scss' scoped>
.iconfont1{
    font-family:"iconfont" !important;
    font-size: 26px;
    font-style: normal;
    color: #fff;
    cursor: pointer;
    margin-right: 0;
}
.container{
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
}
main{
    overflow: hidden;
    background: #fff;
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 0 8px;
}
.dialogdiv{
    display: flex;
    justify-content: space-between;
    height: 34.375rem;
    width: 100%;
    .el-form{
        width: 46%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-bottom: 0;
        border-right:1px solid #ccc;
        padding-right: 20px;
    }
    .map{
        width: 52%;
        height: 34.375rem;
    }
}
.formbigdiv{
    display: flex;
    height: 600px;
}
.dialog{
    .dialog-content{
        color: #000;
        line-height: 1.5625rem;
        width: 80%;
        margin-left: 10%;
        letter-spacing: 1px;
        flex: 1;
        font-size: 1.0625rem;
    }
    .dialog-footer{
        font-weight: 600;
        height: 40%;
        width: 80%;
        margin-left: 10%;
        margin-top: 5%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        .dialog-btn{
            width: 29%;
            height: 1.9rem;
            color: #fff;
            background: #AD454E;
            line-height: 0;
            border-radius: 5px;
            cursor: pointer;
        }
        .btn2{
            background: #B3B3B3
        }
        .dialog-btn:active{background: rgba($color: #AD454E, $alpha: 0.9);}
        .btn2:active{background: rgba($color: #B3B3B3, $alpha: 0.9);}
    }
}
</style>